module.exports = __webpack_public_path__ + "14four/static/media/TwoThumbsIcon.88f73689.png";